/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useLayoutEffect, useState } from "react";
import { Box, Container, IconButton, makeStyles } from "@material-ui/core";
import {
  FilterButton,
  HeaderWithButtons,
  Searchbar,
} from "../components-molecules";
import CssBaseline from "@material-ui/core/CssBaseline";
import { theme } from "../constants/theme";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import { InvoiceButtonSection } from "../components-molecules/InvoiceButtonSection";
import { InvoiceGroupItem } from "../components-molecules/InvoiceGroupItem";
import { useDispatch, useSelector } from "react-redux";
import { CircularProggressIndicator } from "../components-atoms/CircularProggressIndicator";
import multiDownload from "multi-download";
import { debounce } from "lodash";
import { MerchantInvoiceShop } from "../redux/reducers/getInvoiceShops";
import { IFilter, IFilterOption } from "../components-molecules/FilterButton";
import { getInvoiceShops } from "../redux/actions/getInvoiceShops";
import InfiniteScroll from "react-infinite-scroll-component";
import { NoResultsFound } from "../components-molecules/NoResultsFound";
import { getMerchantInvoices } from "../redux/actions/getMerchantInvoices";
import { buttonHoverAndActive } from "../utils/styles/buttonStyles";
import { useTranslation } from 'react-i18next';

export type OrderSortType = "asc" | "desc";
const debounceDuration = 500;
interface Filter extends IFilter {
  Date: Array<Date | null>;
  Shops: string[];
  InvoiceType: string[];
}
const MerchantInvoices = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const pageSize = 10;
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [selectedInvoices, setSelectedInvoices] = useState<string[]>([]);
  const [invoices, setInvoices] = useState<any>(
    []
  );
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [invoiceShops, loading]: [
    MerchantInvoiceShop[],
    boolean
  ] = useSelector((state: any) => [
    state.getInvoiceShops.data,
    state.getMerchantInvoices.loading,
  ]);
  const [filter, setFilter] = useState<Filter>({
    Date: [],
    Shops: [],
    InvoiceType: [],
  });
  const [filterOptions, setFilterOptions] = useState<IFilterOption>({
    Date: [
      { title: "From", value: "" },
      { title: "To", value: "" },
    ],
    Shops: [],
    InvoiceType: [
      { title: t('merchant.merchantFees'), value: "tradekartfee" },
      { title: t('merchant.tradekartCollectOnly'), value: "tradekartcollect" },
      { title: t('merchant.shopOnly'), value: "shop" },
    ],
  });
  const [filterApplied, setFilterApplied] = useState(filtersApplied(filter));

  useLayoutEffect(() => {
    dispatch(getInvoiceShops(false));
  }, [dispatch]);
  useEffect(() => {
    const shopOptions = invoiceShops?.map((m) => ({
      title: m.ShopName,
      value: m.ShopId,
    }));
    setFilterOptions((prev) => ({
      ...prev,
      Shops: shopOptions,
    }));
  }, [dispatch, invoiceShops]);

  useEffect(() => {
    setFilterApplied(filtersApplied(filter));
  }, [filter]);

  const getInvoices = useCallback(
    (
      size = pageSize,
      currentPage = 0,
      prevData = []
    ) => {
      dispatch(
        getMerchantInvoices(
          {
            Page: currentPage,
            Size: size,
            Query: searchQuery,
            Filter: {
              DateFrom: filter.Date?.[0]
                ? new Date(filter.Date[0] as Date)
                : undefined,
              DateTo: filter.Date?.[1]
                ? new Date(filter.Date[1] as Date)
                : undefined,
              Shops: filter.Shops,
              InvoiceType: {
                TradeKartFee: filter.InvoiceType.includes("tradekartfee"),
                TradeKartCollect: filter.InvoiceType.includes("tradekartcollect"),
                Shop: filter.InvoiceType.includes("shop"),
              },
            },
          },
          (resp) => {
            const response = resp.Result;
            let temp = [...prevData];
            let total = prevData.map((m) => m.Invoices).flat().length + 1;

            response.InvoiceGroups.forEach((m) => {
              if (m.Invoices) {
                total += m.Invoices.length;
              }
              const tempMatch = temp.find((f) => f.OrderNo === m.OrderNo);
              if (tempMatch) {
                temp[temp.indexOf(tempMatch)].Invoices = [
                  ...temp[temp.indexOf(tempMatch)].Invoices,
                  ...m.Invoices,
                ];
              } else {
                temp = [...temp, m];
              }
            });

            if (response.length === 0) {
              total--;
            }

            setTotal(total);
            setInvoices(temp);
          }
        )
      );
    },
    [dispatch, searchQuery, filter]
  );
  useEffect(() => {
    getInvoices();
  }, [getInvoices]);
  const loadMore = () => {
    getInvoices(pageSize, page + 1, invoices);
    setPage((prev) => prev + 1);
  };
  const filterOnSubmit = (filter) => {
    setFilter(filter as Filter);
  };

  const onCheckboxChange = (data, value) => {
    if (value) {
      setSelectedInvoices((prev) => [...prev, data.InvoiceNo]);
    } else {
      setSelectedInvoices((prev) => [
        ...prev.filter((f) => f !== data.InvoiceNo),
      ]);
    }
  };
  const downloadPdfs = async () => {
    let blobs: Array<any> = [];
    let invoiceNames: Array<String> = [];
    const selectedList = invoices
      .map((m) => m.Invoices)
      .flat()
      .filter((f) => selectedInvoices.includes(f.InvoiceNo));
    selectedList.forEach(async (item, index: number) => {
      const data = await fetch(item.FileUrl, {
        method: "GET",
        mode: "cors",
        headers: { Accept: "form-data" },
      });

      const convertedToBlob = await data.blob();
      const convertedToUrl = await window.URL.createObjectURL(
        new Blob([convertedToBlob])
      );
      blobs.push(convertedToUrl);
      invoiceNames.push(item.InvoiceNo);
      if (selectedInvoices.length - 1 === index) {
        multiDownload(blobs, {
          rename: ({ url, index, urls }) => invoiceNames[index] + ".pdf",
        });
      }
    });
  };
  const selectAllClicked = () => {
    setSelectedInvoices(
      invoices
        .map((m) => m.Invoices)
        .flat()
        .map((m) => m.InvoiceNo)
    );
  };
  const clearAllClicked = () => {
    setSelectedInvoices([]);
  };

  return (
    <Box className={classes.container}>
      <CssBaseline />
      <Container className={classes.root}>
        <CssBaseline />
        <HeaderWithButtons title={t('merchant.invoices')}>
          <HeaderWithButtons.ButtonArea>
            <>
              <FilterButton
                dateKey="Date"
                singleDate
                defaultOption="Date"
                data-automation="filter-button"
                onSubmit={filterOnSubmit}
                inButtonSet
                options={filterOptions}
                filter={filter}
              />
              <IconButton
                data-automation="search-button"
                className={classes.searchButton}
                color="primary"
                onClick={() =>
                  searchOpen ? setSearchOpen(false) : setSearchOpen(true)
                }
              >
                <SearchRoundedIcon
                  color="primary"
                  className={classes.searchIcon}
                />
              </IconButton>
            </>
          </HeaderWithButtons.ButtonArea>
        </HeaderWithButtons>
        <Searchbar
          query={searchQuery}
          isOpen={searchOpen}
placeholder={t('merchant.searchInvoices')}
          onCancel={() => {
            setSearchOpen(false);
            debounce((e) => setSearchQuery(e), debounceDuration)("");
          }}
          onChange={(event) => {
            debounce(
              (e) => setSearchQuery(e.target.value),
              debounceDuration
            )(event);
          }}
        />
        {loading && page === 0 ? (
          <CircularProggressIndicator />
        ) : (
          <div className={classes.contentContainer}>
            {invoices.length !== 0 ? (
              <InvoiceButtonSection
                downloadClicked={downloadPdfs}
                downloadDisabled={selectedInvoices.length === 0}
                selectAllClicked={selectAllClicked}
                clearAllClicked={clearAllClicked}
                clearAllDisabled={selectedInvoices.length === 0}
              />
            ) : null}
            <div className={classes.invoiceSection}>
              {invoices.length !== 0 ? (
                <InfiniteScroll
                  style={{ overflow: "hidden" }}
                  dataLength={invoices.map((m) => m.Invoices).flat().length} // This is important field to render the next data
                  next={() => loadMore()}
                  scrollThreshold={0.8}
                  hasMore={
                    invoices.map((m) => m.Invoices).flat().length !== total
                  }
                  loader={<CircularProggressIndicator />}
                >
                  {invoices.map((groupItem, index: number) => {
                    return (
                      <InvoiceGroupItem
                        key={index}
                        selectedItems={selectedInvoices}
                        data={groupItem}
                        onCheckboxChange={onCheckboxChange}
                      />
                    );
                  })}
                </InfiniteScroll>
              ) : (
                <NoResultsFound
                  query={searchQuery}
                  filterApplied={filterApplied}
                />
              )}
            </div>
          </div>
        )}
      </Container>
    </Box>
  );
};

const filtersApplied = (filter: any) => {
  let applied = false;

  Object.values(filter).forEach((x: any) => {
    if (x.length > 0) {
      applied = true;
    }
  });
  return applied;
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    flexGrow: 1,
    maxWidth: 840,
    paddingLeft: 0,
    paddingRight: 0,
  },
  searchIcon: {
    width: 24,
    height: 24,
  },
  searchButton: {
    width: 40,
    height: 40,
    marginLeft: 8,
    marginRight: 24,
    alignSelf: "center",
    ...buttonHoverAndActive
  },
  contentContainer: {
    //
  },
  invoiceSection: {
    //
  },

  textButton: {
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
    "&:active": {
      backgroundColor: theme.palette.secondary[24],
    },
  },
  printButtonText: {
    textTransform: "none",
  },
  noSearchResults: {
    display: "flex",
    paddingLeft: 24,
    paddingTop: 40,
    flexDirection: "column",
  },
  noRecordsFound: {
    display: "flex",
    paddingLeft: "24px",
    flexDirection: "column",
    paddingTop: "96px",
  },
});

export default MerchantInvoices;
